<template>
    <div class="table-responsive">
        <h4>Code promotionnels</h4>
        <table class="table table-hover table-condensed table-detailed search-table" id="detailedTable">
            <thead>
                <tr>
                    <th class="small-cell">Date de création</th>
                    <th>Identifiant</th>
                    <th class="small-cell">État</th>
                    <th class="small-cell">Date d'utilisation</th>
                    <th class="small-cell">Date d'expiration</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(promoCode, pcIndex) in orderedPromoCodes" :key="pcIndex">
                    <td>{{ formatDate(promoCode.created_at) }}</td>
                    <td>{{ promoCode.code }}</td>
                    <td>{{ promoCode.decoded_state }}</td>
                    <td>{{ promoCode.used_at ? formatDate(promoCode.used_at) : '-' }}</td>
                    <td>{{ formatDate(promoCode.expires_at) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import dateFormatting from '../../../mixins/dateFormatting'

export default {
    name: 'promoCodes',

    props: [
        'promoCodes'
    ],

    mixins: [
        dateFormatting
    ],

    computed: {
        orderedPromoCodes () {
            return _.reverse(this.promoCodes)
        }
    }
}
</script>

<style lang="scss" scoped>
.small-cell {
    width: 150px;
}
</style>





// WEBPACK FOOTER //
// client/components/Customer/LoyaltyProgram/PromoCodes.vue